import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'petition-video',
		path: '/p/:slug/v/:videoId',
		component: loadable(async () => import(/* webpackChunkName: "pages/petition-video" */ './index'), {
			exportName: 'PetitionVideo',
			fallback: Loading,
		}),
		frame: {
			header: true,
			footer: true,
		},
		ssr: {
			enabled: true,
			seo: false,
		},
	},
];
